import { dayjs } from '../date/date';
import { Brand, flow } from '../effect';

export const makeIanaTimezone = Brand.nominal<IanaTimezone>();

export const getLocalTz: () => IanaTimezone = flow(dayjs.tz.guess as () => string, makeIanaTimezone);
